import React, {useEffect, useState, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import {useHistory, useLocation} from "react-router-dom";
// import TabNav from "@artibulles-cis/react/TabNav";
import TabNav from "../../../../../artibulles-cis/TabNav/TabNav";

import TasksViewAllTasksTable from "./TasksViewAllTasksTable";
import TasksViewAllTasksTableToday from "./TasksViewAllTasksTableToday";
//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    ClassExtendTabNavLink: {
        borderRight: "1px solid rgb(220 220 220)",
    },
}));

const Component = React.memo(function Component(props) {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/

    /***************** REFS ******************/

    /***************** CONST ******************/
	const History = useHistory();
	const PathName = Location.pathname;
    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
	const HandleCreateTask = () => {
        History.push(`/tasks/task/edit/new`, {from : PathName});
    };
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <TabNav
            MainSlug={`/tasks/tables`}
            DefaultTab={`/tasks/tables/today`}
            ClassExtendTabNavLink={classes.ClassExtendTabNavLink}
			TabNavMenuHeight="30px"
            ActiveIndicator={{
                WithIndicator: true,
                Position: "Bottom",
            }}
            TabMenuContent={[
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Create Task</div>
                        </div>
                    ),
                    Slug: `/tasks/create`,
					SimpleButton : true,
					
                    // ShowOnlyIfActive: false,
					OnClick : HandleCreateTask
					// exact : true,
                    // TabContent: <TasksViewAllTasksTable />,
                },
				{
                    TabMenu: (
						
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Today</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/today`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTableToday />,
                },
				{
                    TabMenu: (
						
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Due</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/due`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTable />,
                },
                
                
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Weekly</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/weekly`,
					exact : true,
                    ShowOnlyIfActive: false,
                    TabContent: <TasksViewAllTasksTable />,
                },
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Monthly</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/monthly`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTable />,
                },
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>All Tasks</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/all`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTable />,
                },
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Work</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/monthly`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTable />,
                },
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Perso</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/monthly`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTable />,
                },
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Completed</div>
                        </div>
                    ),
                    Slug: `/tasks/tables/monthly`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <TasksViewAllTasksTable />,
                }
            ]}
        />
    );

    /***************** RENDER ******************/
});

export default Component;
